module.exports = __webpack_public_path__ + "static/media/OwnerAppScreenshot.de7e2b20.png";